export const GET_MATERIAL = "GET_MATERIAL"
export const GET_MATERIAL_SUCCESS = "GET_MATERIAL_SUCCESS"
export const GET_MATERIAL_FAIL = "GET_MATERIAL_FAIL"

export const SAVE_MATERIAL = "SAVE_MATERIAL"
export const SAVE_MATERIAL_SUCCESS = "SAVE_MATERIAL_SUCCESS"
export const SAVE_MATERIAL_FAIL = "SAVE_MATERIAL_FAIL"

export const UPDATE_MATERIAL = "UPDATE_MATERIAL"
export const UPDATE_MATERIAL_SUCCESS = "UPDATE_MATERIAL_SUCCESS"
export const UPDATE_MATERIAL_FAIL = "UPDATE_MATERIAL_FAIL"

export const DELETE_MATERIAL = "DELETE_MATERIAL"
export const DELETE_MATERIAL_SUCCESS = "DELETE_MATERIAL_SUCCESS"
export const DELETE_MATERIAL_FAIL = "DELETE_MATERIAL_FAIL"

export const CLEAN_MATERIAL = "CLEAN_MATERIAL"

export const SAVE_MASSIVE_CHARGE = "SAVE_MASSIVE_CHARGE"
export const SAVE_MASSIVE_CHARGE_ERROR = "SAVE_MASSIVE_CHARGE_ERROR"
export const SAVE_MASSIVE_CHARGE_SUCCESS = "SAVE_MASSIVE_CHARGE_SUCCESS"
